import { render, staticRenderFns } from "./MappingAdd.vue?vue&type=template&id=3e694deb&"
import script from "./MappingAdd.vue?vue&type=script&lang=js&"
export * from "./MappingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports